var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1936_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3076 7.33344C14.2204 7.33344 14.1339 7.29586 14.0743 7.22324L12.5441 5.36141C12.4482 5.24473 12.3065 5.17781 12.1555 5.17781H11.3285C11.1618 5.17781 11.0267 5.0427 11.0267 4.87602C11.0267 4.7093 11.1618 4.57422 11.3285 4.57422H12.1555C12.4877 4.57422 12.7993 4.72145 13.0104 4.97816L14.5406 6.84004C14.6464 6.96883 14.6278 7.15898 14.499 7.2648C14.4429 7.31094 14.375 7.33344 14.3076 7.33344Z",
    fill: "#7A838B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62172 17.9173C5.62194 17.9173 7.24344 16.2958 7.24344 14.2955C7.24344 12.2953 5.62194 10.6738 3.62172 10.6738C1.6215 10.6738 0 12.2953 0 14.2955C0 16.2958 1.6215 17.9173 3.62172 17.9173Z",
    fill: "#5D6972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62169 16.3073C4.73293 16.3073 5.63376 15.4065 5.63376 14.2953C5.63376 13.184 4.73293 12.2832 3.62169 12.2832C2.51045 12.2832 1.60962 13.184 1.60962 14.2953C1.60962 15.4065 2.51045 16.3073 3.62169 16.3073Z",
    fill: "#979FB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.521 5.91665L17.0588 6.6322C16.8057 6.61126 15.8972 6.66899 15.6816 6.53579L14.0578 4.09532L14.3314 5.19591C14.3351 5.21079 14.3387 5.2261 14.3419 5.24099L13.8586 3.30696C13.7862 3.01845 14.0417 2.75407 14.3327 2.81563C16.5865 3.2897 18.3922 4.24181 19.521 5.91665Z",
    fill: "#A7D0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9694 15.2844L11.1645 8.44336L2.81689 9.00996L6.79275 13.025L11.9694 15.2844Z",
    fill: "#979FB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3783 17.9173C18.3785 17.9173 20 16.2958 20 14.2955C20 12.2953 18.3785 10.6738 16.3783 10.6738C14.3781 10.6738 12.7566 12.2953 12.7566 14.2955C12.7566 16.2958 14.3781 17.9173 16.3783 17.9173Z",
    fill: "#5D6972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3783 16.3073C17.4895 16.3073 18.3904 15.4065 18.3904 14.2953C18.3904 13.184 17.4895 12.2832 16.3783 12.2832C15.267 12.2832 14.3662 13.184 14.3662 14.2953C14.3662 15.4065 15.267 16.3073 16.3783 16.3073Z",
    fill: "#979FB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1858 10.2411C15.5687 10.1286 15.9694 10.0703 16.3783 10.0703C17.6881 10.0703 18.9029 10.6648 19.7113 11.7013C19.8829 11.9213 19.784 12.245 19.5187 12.3314L16.1009 13.4453C16.1009 13.4453 14.5347 10.4325 15.1858 10.2411Z",
    fill: "#FFF1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9039 14.1148C16.9039 14.3816 16.726 14.6254 16.4564 14.6979C16.1344 14.784 15.8032 14.5929 15.7171 14.2709L14.3075 9.00977H15.5574L16.8834 13.9583C16.8974 14.0105 16.9039 14.0629 16.9039 14.1148Z",
    fill: "#A7D0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.1102V8.47656C0 8.0923 0.137461 7.72074 0.3875 7.42902L1.20723 6.47266L2.81687 7.67988L1.38617 8.57406C1.26887 8.64738 1.17242 8.74973 1.10617 8.87117L0.377852 10.2065C0.278047 10.3895 0 10.3186 0 10.1102Z",
    fill: "#8991A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18305 9.00848H2.81688L1.14684 7.39879L0.508713 6.76066C0.00168192 6.25363 0.360783 5.38672 1.07781 5.38672H1.61313C2.01422 5.38672 2.40086 5.53645 2.69731 5.8066L3.56137 6.59395L7.18305 9.00848Z",
    fill: "#F8C460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76433 7.60156L5.95519 6.89285C5.73507 6.70004 5.45238 6.59375 5.15976 6.59375H3.5614L6.84007 9.50812C7.06105 9.70457 7.34644 9.81305 7.6421 9.81305H9.55003L10.0503 7.80098H7.2946C7.09953 7.80098 6.91109 7.73012 6.76433 7.60156Z",
    fill: "#8991A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8509 13.4452L6.53528 12.7648L9.55 9.81457L11.7927 9.00977L11.8509 13.4452Z",
    fill: "#A7ADBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8913 6.50505L12.7694 9.81368H11.5469C10.2326 9.36392 9.68396 8.71142 9.68396 7.82091C9.68396 7.29052 10.284 6.59454 10.8829 6.21368C11.7107 6.00888 12.5968 6.04306 13.433 6.34165L13.8913 6.50505Z",
    fill: "#FFF8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5469 9.81289H9.55017L8.40369 7.80082L8.77673 7.41852C9.36505 6.8157 10.0974 6.40687 10.883 6.21289C10.6238 6.62777 10.4737 7.12156 10.4737 7.65195C10.4737 8.5425 10.897 9.33043 11.5469 9.81289Z",
    fill: "#FFF1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8805 8.91875C19.6733 9.44633 19.2048 9.86121 18.5988 9.96785C17.3763 10.1832 15.6708 10.6991 14.2865 11.9349C13.2258 12.3593 11.9314 12.4975 11.8509 12.4645C10.5454 11.93 12.1541 9.7059 12.7103 8.21898L13.7279 6.79727C14.0024 6.41375 14.0949 5.92926 13.9811 5.47168L13.7074 4.37109L15.9408 5.75016C16.1565 5.88336 16.4008 5.96383 16.6539 5.98477L19.171 6.19242C19.3968 6.52762 19.6491 6.98559 19.8471 7.57352C19.8471 7.57352 19.4173 8.12563 19.5791 8.16629L19.8805 8.91875Z",
    fill: "#F8C460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0422 11.8505C14.1227 11.8836 14.2044 11.9117 14.2865 11.9346C13.3122 12.8043 12.4974 14.0308 12.1215 15.7596C12.0008 16.3145 11.5098 16.7097 10.942 16.7097H9.11181C8.66755 16.7097 8.25912 16.4658 8.04865 16.0747L7.23376 14.56L7.37341 13.222L9.38751 12.861L12.7102 8.21875C12.1541 9.70566 12.7368 11.3161 14.0422 11.8505Z",
    fill: "#FAAF42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74311 12.1465L5.18311 13.0234C4.40744 13.1726 3.69428 13.5509 3.13572 14.1094C2.87358 14.3715 3.07533 14.8187 3.44537 14.7955L9.94436 14.3894L9.74311 12.1465Z",
    fill: "#A7D0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93969 14.6294C10.7175 14.6294 11.3481 13.9988 11.3481 13.2209C11.3481 12.4431 10.7175 11.8125 9.93969 11.8125C9.16183 11.8125 8.53125 12.4431 8.53125 13.2209C8.53125 13.9988 9.16183 14.6294 9.93969 14.6294Z",
    fill: "#80BBCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8804 8.91735L19.1559 8.73614C18.994 8.69563 18.8487 8.60582 18.74 8.47914L18.3951 8.07676C18.1535 7.79489 18.39 7.36403 18.7575 7.41649L19.8474 7.57207C19.8764 7.6586 19.9042 7.74793 19.9307 7.84008C20.0374 8.2111 20.0104 8.58657 19.8804 8.91735Z",
    fill: "#F9EE80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1936_3598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeIcon);
export default __webpack_public_path__ + "static/media/bikeIcon.7cd52801947e662ef8373e91c6fe46a6.svg";
export { ForwardRef as ReactComponent };